import styles from "Styles/SuggestedBlogPosts.module.css";
import { motion } from "framer-motion";
import emoji from "Assets/emoji/speaker.svg";

export default function SuggestedBlogPosts({
  title = "掌握最新數位行銷趨勢",
  links = [],
}) {
  if (!links.length) return;

  let slicedLinks = [];
  if (links.length > 3) {
    slicedLinks = links.slice(0, 3);
  } else {
    slicedLinks = links;
  }

  const textVariant = {
    initial: {
      y: 0,
    },
    animate: {
      transition: {
        duration: 0.4,
        type: "spring",
        mass: 1.5,
      },
      y: [0, 10],
      x: [0, 1.5],
    },
  };

  const imageVariant = {
    initial: {
      opacity: 0,
      y: 100,
      x: 0,
    },
    animate: {
      opacity: [0, 1],
      y: -100,
      x: 5,
      transition: {
        type: "spring",
        mass: 0.8,
        damping: 8,
      },
      rotate: [-2, 10],
      boxShadow: "15px 25px 70px rgba(32, 236, 142, 0.7)",
    },
  };

  return (
    <>
      {slicedLinks.length > 0 && (
        <section className={styles.section}>
          <div className={styles.container}>
            <div className={styles.sectionHeadingContainer}>
              <h2 className={styles.sectionHeading}>
                <img
                  style={{
                    position: "absolute",
                    left: "-120px",
                    top: "-20px",
                  }}
                  className={styles.emoji}
                  src={emoji}
                  alt="emoji"
                />
                {title}
              </h2>
            </div>
            <div>
              <ol className={styles.list}>
                {slicedLinks.map((link, index) => (
                  <motion.li
                    initial="initial"
                    whileHover="animate"
                    className={styles.listItem}
                    key={index}
                  >
                    <motion.a
                      variants={textVariant}
                      className={styles.listLink}
                      href={link.url}
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      {link.label}
                    </motion.a>
                    <motion.div
                      variants={imageVariant}
                      className={styles.imageWrapper}
                    >
                      <img
                        className={styles.image}
                        src={link.featuredImage.src}
                        alt={link.featuredImage.alt}
                      />
                    </motion.div>
                  </motion.li>
                ))}
              </ol>
            </div>
          </div>
        </section>
      )}
    </>
  );
}
